import { Observable } from 'rxjs';
import { ApiService } from '@app/core';
import { Injectable } from '@angular/core';
import { ContactUsConstants } from '@app/constants';
import { IContactUsList } from '@app/core/models/contact-us.interface';

@Injectable({
  providedIn: 'root'
})
export class ContactUsService {
  constructor(private readonly apiService: ApiService) { }

  public getContactUsList(): Observable<IContactUsList> {
    return this.apiService.get(ContactUsConstants.getContactUsUrl);
  }
}
